import React from 'react';
import Hero from '../components/Hero';
import PriceCalculator from '../components/PriceCalculator';
import ServicesSection from '../components/ServicesSection';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import CTASection from '../components/CTASection';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <PriceCalculator />
      <ServicesSection />
      <WhyChooseUs />
      <Testimonials />
      <CTASection />
    </main>
  );
};

export default HomePage;
